import {
    IEditorEditableServiceLayer,
} from '@src/slide/application/entry/toc/editor/base/service-layer/editable-service-layer.interface';
import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import { IClearFormat } from '@src/slide/application/service/clear-format/clear-format.interface';
import ClearFormatManager from '@src/slide/application/service/clear-format';
import ImportNewFileManager from '@src/slide/application/service/import-file-manager/core/import-new-file-manager';
import {
    IEditorViewableServiceLayer,
} from '@src/slide/application/entry/toc/editor/base/service-layer/viewable-service-layer.interface';
import PreviewService from '@src/slide/application/service/preview-service';
import { LockService } from '@src/slide/application/service/lock-service';
import { IDragElementHandler } from '@src/slide/application/service/edit-action-services/drag-element-handler/drag-element-handler.interface';
import DragElementHandler from '@src/slide/application/service/edit-action-services/drag-element-handler';
import { IMoveElementManager } from '@src/slide/application/service/move-element-manager/move-element-manager.interface';
import MoveElementManager from '@src/slide/application/service/move-element-manager';
import { IRotateElementHandler } from '@src/slide/application/service/edit-action-services/rotate-element-handler/rotate-element-handler.interface';
import { IResizeElementHandler } from '@src/slide/application/service/edit-action-services/resize-element-handler/resize-element-handler.interface';
import RotateElementHandler from '@src/slide/application/service/edit-action-services/rotate-element-handler';
import ResizeElementHandler from '@src/slide/application/service/edit-action-services/resize-element-handler';
import { BorderSketchManager } from '@src/slide/application/service/border-sketch-manager';
import ElementAutoLayoutService from '@src/slide/application/service/element-auto-layout-service';
import { IElementAutoLayoutService } from '@src/slide/application/service/element-auto-layout-service/element-auto-layout-service.interface';
import ColorPickerManager from '@src/slide/application/service/color-picker-manager';
import { ThemeColorManager } from '@src/slide/application/service/theme-color-manager';
import { BaseEditableServiceLayer } from '@src/slide/application/entry/toc/base/service-layer/base-editable-service-layer';
import { IDocRecoverService } from '@src/slide/application/service/doc-recover/core/doc-recover-service.interface';
import { DocRecoverService } from '@src/slide/application/service/doc-recover/core';
import { IFormatBrushManager } from '@src/slide/application/service/format-brush/core/interface';
import FormatBrushManager from '@src/slide/application/service/format-brush/core';
import { IMenuDataWorkerManager } from '@src/slide/application/service/menu-data-worker/core/interface';
import MenuDataWorkerManager from '@src/slide/application/service/menu-data-worker/core';
import { DynamicServiceLoader, IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';
import { ITransferAuthManager } from '@src/slide/application/service/transfer-auth-manager/core/transfer-auth-manager.interface';
import { transferAuthManagerDynamicConfig } from './service-dynamic-configs/transfer-auth-manager.config';
import { IOcrService } from '@src/slide/application/service/ocr-service/core/ocr-service.interface';
import { ImportNewFileManagerInjectable } from '@src/slide/application/service/import-file-manager/inject/import-new-file-manager-injectable';
import { IFormulaOcrManager } from '@src/slide/application/service/formula-ocr-manager/core/interface';
import { formulaOcrManagerDynamicConfig } from '@src/slide/application/entry/toc/editor/base/service-layer/service-dynamic-configs/formula-ocr-manager.config';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { AIAssistantService } from '@src/slide/application/service/ai-ssistant/ai-ssistant-service';
import { IAIAssistantService } from '@src/slide/application/service/ai-ssistant/ai-ssistant-service.interface';
import { IQuickToolDialogManager } from '@src/slide/application/service/quick-tool-dialog-manager/core/quick-tool-dialog-manager.interface';
import { SlideContentEnumeratorService } from '@src/slide/application/service/slide-content-enumerator/slide-content-enumerator-service';
import { SlideContentLayoutAnalyzerService } from '@src/slide/application/service/slide-content-layout-analyzer/core/slide-content-layout-analyzer-service';
import { ISlideContentLayoutAnalyzerService } from '@src/slide/application/service/slide-content-layout-analyzer/core/slide-content-layout-analyzer-service.interface';
import { quickToolDialogManagerDynamicConfig } from '../../pc/service-layer/service-dynamic-configs/quick-tool-dialog.config';
import { ISnapLineService } from '@src/slide/application/service/snap-line-service/interface/snap-line-service.interface';
import { SnapLineService } from '@src/slide/application/service/snap-line-service';
import { IAiService } from '@src/slide/application/service/ai/core/base/ai-service.interface';
import { IAiController } from '@src/slide/application/service/ai-controller/core/base/ai-controller.interface';
import {
    pcChangeTemplateServiceDynamicConfig,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/change-template-service.config';
import { IChangeTemplateService } from '@src/slide/application/service/change-template-service/index.interface';
import {
    ITemplateContentAnalyzerService,
} from '@src/slide/application/service/template-content-analyzer-service/index.interface';
import {
    templateAnalyzerConfig,
} from '@src/slide/application/entry/toc/editor/pc/service-layer/service-dynamic-configs/template-analyzer.config';
import { TemplateFormatService } from '@src/slide/application/service/template-format-service';
import {
    templateMallContentDynamicConfig,
} from '@src/slide/application/entry/toc/editor/base/service-layer/service-dynamic-configs/template-mall-content-manager.config';
import {
    ITemplateMallManager,
} from '@src/slide/application/service/template-mall-content-manager/interface';
import { IAnimBrushManager } from '@src/slide/application/service/anim-brush/core/interface';
import { shouldDisableNetwork } from '@src/slide/infrastructure/module/dependent/socket';
import { getAnimBrushManagerDynamicConfig } from './service-dynamic-configs/anim-brush-manager.config';
import { IAIFloatManager } from '@src/slide/application/service/ai-float-manager/ai-manager.interface';
import AiFloatManager from '@src/slide/application/service/ai-float-manager';

export class EditorEditableServiceLayer extends BaseEditableServiceLayer implements IEditorEditableServiceLayer {
    public formulaOcrManager: IDynamicService<IFormulaOcrManager>;
    public clearFormatManager: IClearFormat;
    public importNewFileManager: ImportNewFileManager;
    public readonly previewService: PreviewService;
    public lockService: LockService;
    public readonly dragElementHandler: IDragElementHandler;
    public readonly templateFormatService: TemplateFormatService;
    public readonly moveElementManager: IMoveElementManager;
    public readonly rotateElementHandler: IRotateElementHandler;
    public readonly resizeElementHandler: IResizeElementHandler;
    public readonly snapLineService: ISnapLineService;
    public readonly borderSketchManager: BorderSketchManager;
    public readonly colorPickerManager: ColorPickerManager;
    public readonly themeColorManager: ThemeColorManager;
    public readonly elementAutoLayoutService: IElementAutoLayoutService;
    public readonly docRecoverService: IDocRecoverService;
    public readonly formatBrushManager: IFormatBrushManager;
    public readonly menuDataWorkerManager: IMenuDataWorkerManager;
    public readonly transferAuthManager: IDynamicService<ITransferAuthManager>;
    public animBrushManager: IAnimBrushManager;
    public ocrService: IDynamicService<IOcrService>;
    public aiService: IDynamicService<IAiService>;
    public aiController: IAiController;
    public templateMallContentManager: IDynamicService<ITemplateMallManager>;

    public readonly contentLayoutAnalyzer: ISlideContentLayoutAnalyzerService;
    public readonly templateContentAnalyzerService: IDynamicService<ITemplateContentAnalyzerService>;
    public readonly slideContentEnumeratorService: SlideContentEnumeratorService;
    public readonly aiAssistantService: IAIAssistantService;

    public readonly quickToolDialogManager: IDynamicService<IQuickToolDialogManager>;

    public readonly changeTemplateService?: IDynamicService<IChangeTemplateService>;
    public readonly aiFloatManager?: AiFloatManager;
    // 异步实例用于注入其他 service 中
    protected dynamicAnimBrushManager: IDynamicService<IAnimBrushManager>;

    public constructor(
        viewableServices: IEditorViewableServiceLayer,
        uiDataService: IUiDataService,
    ) {
        super(uiDataService, viewableServices);

        this.menuManager.setExportImageManagerDelegate(viewableServices.exportImageManager);
        this.formulaOcrManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(formulaOcrManagerDynamicConfig);
        this.clearFormatManager = new ClearFormatManager();
        this.clearFormatManager.setSelectionServiceDelegate(viewableServices.selectionService);
        this.importNewFileManager = new ImportNewFileManager(new ImportNewFileManagerInjectable());
        this.importNewFileManager.setUiDataServiceDelegate(uiDataService);
        this.importNewFileManager.setSelectionServiceDelegate(viewableServices.selectionService);
        this.elementAutoLayoutService = new ElementAutoLayoutService({
            selectionService: viewableServices.selectionService,
        });
        this.previewService = new PreviewService();
        this.lockService = new LockService();
        this.lockService.setSelectionServiceDelegate(viewableServices.selectionService);
        this.lockService.setUserPriviledgeServiceDelegate(viewableServices.userPriviledgeService);
        this.lockService.setMenuManagerDelegate(this.menuManager);
        this.lockService.setEditingStateManagerDelegate(viewableServices.editingStateManager);
        this.lockService.setTextEditorStateService(viewableServices.textEditorStateService);
        this.lockService.setEditorInstanceService(viewableServices.editorInstanceService);
        this.lockService.initEvents();
        viewableServices.selectionEventService.setLockServiceDelegate(this.lockService);
        this.borderSketchManager = new BorderSketchManager();
        this.moveElementManager = new MoveElementManager(
            this.menuManager,
            viewableServices.editingStateManager,
            viewableServices.selectionService,
            viewableServices.userPriviledgeService,
        );
        this.dragElementHandler = new DragElementHandler(
            viewableServices.selectionService,
            viewableServices.editorInstanceService,
            viewableServices.editingStateManager,
            viewableServices.linkManager,
        );
        this.rotateElementHandler = new RotateElementHandler(
            viewableServices.editingStateManager,
            this.moveElementManager,
            viewableServices.selectionService,
            viewableServices.linkManager,
        );
        this.resizeElementHandler = new ResizeElementHandler(
            viewableServices.editingStateManager,
            this.moveElementManager,
            viewableServices.selectionService,
            this.borderSketchManager,
            viewableServices.linkManager,
        );
        this.snapLineService = new SnapLineService(
            this.dragElementHandler,
            this.resizeElementHandler,
            viewableServices.selectionService,
            viewableServices.editAreaCanvasSizeManager,
            this.menuManager,
            uiDataService,
        );
        viewableServices.addonManager.setFormulaOcrManager(this.formulaOcrManager);
        this.colorPickerManager = new ColorPickerManager({
            menuManager: this.menuManager,
        });

        this.themeColorManager = new ThemeColorManager({
            uiDataService,
            selectionService: viewableServices.selectionService,
            slideRenderStateManager: viewableServices.slideRenderStateManager,
        });
        this.menuManager.setThemeColorManager(this.themeColorManager);
        this.docRecoverService = new DocRecoverService();
        this.menuDataWorkerManager = new MenuDataWorkerManager();

        this.dynamicAnimBrushManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(getAnimBrushManagerDynamicConfig({
                userPriviledgeService: viewableServices.userPriviledgeService,
                tipsManager: viewableServices.tipsManager,
                selectionService: viewableServices.selectionService,
            }));

        this.dynamicAnimBrushManager.onDidInit((module) => {
            this.animBrushManager = module;
            this.menuDataWorkerManager.addItemValueWorker(this.animBrushManager);
            this.menuDataWorkerManager.addItemDataWorker(this.animBrushManager);
        });

        this.formatBrushManager = new FormatBrushManager({
            animBrushManager: this.dynamicAnimBrushManager,
            userPriviledgeService: viewableServices.userPriviledgeService, tipsManager: viewableServices.tipsManager,
            borderSketchManager: this.borderSketchManager,
            selectionService: viewableServices.selectionService,
        });
        if (__IS_DEV__ || ENV.IS_TEST) {
            // 格式刷测试接口
            window.formatBrushManager = this.formatBrushManager;
        }
        this.menuDataWorkerManager.addItemValueWorker(this.formatBrushManager);
        this.menuDataWorkerManager.addItemDataWorker(this.formatBrushManager);
        this.transferAuthManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(transferAuthManagerDynamicConfig);

        this.slideContentEnumeratorService = new SlideContentEnumeratorService(uiDataService);
        this.contentLayoutAnalyzer = new SlideContentLayoutAnalyzerService(this.slideContentEnumeratorService);
        this.templateFormatService = new TemplateFormatService();
        this.changeTemplateService = DynamicServiceLoader.getInstance()
            .registerDynamicService(pcChangeTemplateServiceDynamicConfig);
        this.changeTemplateService.onDidInit((module) => {
            module.setDelegate({
                uiDataService,
                themeColorManager: this.themeColorManager,
                selectionService: viewableServices.selectionService,
                slideRenderStateManager: viewableServices.slideRenderStateManager,
                contentLayoutAnalyzer: this.contentLayoutAnalyzer,
                templateContentAnalyzerService: this.templateContentAnalyzerService,
                slideContentEnumeratorService: this.slideContentEnumeratorService,
                templateFormatService: this.templateFormatService,
            });
        });
        this.quickToolDialogManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(quickToolDialogManagerDynamicConfig);
        this.templateContentAnalyzerService = DynamicServiceLoader.getInstance()
            .registerDynamicService(templateAnalyzerConfig);
        this.templateMallContentManager = DynamicServiceLoader.getInstance()
            .registerDynamicService(templateMallContentDynamicConfig);
        this.templateContentAnalyzerService.onDidInit((module) => {
            module.setDelegateService({
                contentLayoutAnalyzer: this.contentLayoutAnalyzer,
                slideRenderStateManager: viewableServices.slideRenderStateManager,
            });
        });
        this.templateMallContentManager.onDidInit((module) => {
            module.setDelegate({
                templateContentAnalyzer: this.templateContentAnalyzerService,
                templateFormatService: this.templateFormatService,
                uiDataService,
            });
        });
        if (!shouldDisableNetwork()) {
            this.aiAssistantService = new AIAssistantService(
                uiDataService,
                this.contentLayoutAnalyzer,
                this.viewableServiceLayer,
                this.templateContentAnalyzerService,
                this.changeTemplateService,
            );
        }
        this.aiFloatManager = new AiFloatManager({
            selectionService: viewableServices.selectionService,
            aiAssistantService: this.aiAssistantService,
        });
    }
}
